module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a8547a49cb272a0281b7eab3144043ca.png";